<template>
    <div class="container">

        <div class="handle-box-search">
            <div class="handle-box">

                <div>


                    <div class="table-head table-head-search">


                        <div>
                            <span class="title">起止时间:</span>
                            <el-date-picker v-model="search_time" type="daterange" range-separator="-"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                            @change="timeChange"
                                            style="width: 300px;">
                            </el-date-picker>
                        </div>
                    </div>


                    <!--
                    <div class="table-head">
                      <div style="margin: 10px 0;" class="search-radio">
                        <span class="title">订单状态:</span>
                        <el-radio-group v-model="search_data.status" size="small">
                          <el-radio label="" border>
                            全部</el-radio>
                          <el-radio label="new" border>新单</el-radio>
                          <el-radio label="serving" border>服务中</el-radio>
                          <el-radio label="proceed" border>前往中</el-radio>
                          <el-radio label="paid" border>已支付</el-radio>
                          <el-radio label="unpaid" border>未支付</el-radio>
                          <el-radio label="order_cancel" border>消单</el-radio>
                        </el-radio-group>
                      </div>

                      <div style="margin: 10px 0;" class="search-radio">
                        <span class="title">订单来源:</span>
                        <el-radio-group v-model="search_data.order_from" size="small">
                          <el-radio label="" border>
                            全部</el-radio>
                          <el-radio label="android" border>安卓端</el-radio>
                          <el-radio label="ios" border>苹果端</el-radio>
                          <el-radio label="h5" border>移动网页</el-radio>
                          <el-radio label="pc" border>PC网页</el-radio>
                          <el-radio label="wx_cgi" border>微信小程序</el-radio>
                        </el-radio-group>
                      </div>

                      <div style="margin: 10px 0;display: flex;" class="search-radio">

                        <div>
                          <span class="title">下单时间:</span>

                          <el-radio-group v-model="order_fixed_time_value" size="small" @change="orderFixedTimeChange">
                            <el-radio label="" border>
                              全部</el-radio>
                            <el-radio label="today" border>今天</el-radio>
                            <el-radio label="yesterday" border>昨天</el-radio>
                            <el-radio label="this_week" border>本周</el-radio>
                            <el-radio label="last_week" border>上周</el-radio>
                            <el-radio label="this_month" border>本月</el-radio>
                            <el-radio label="last_month" border>上月</el-radio>
                            <el-radio label="between" border>自定义时间</el-radio>
                          </el-radio-group>

                        </div>

                        <el-date-picker v-if="order_fixed_time_value == 'between'" v-model="order_time_arrway"
                          type="datetimerange" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" @change="timeChange('order')">
                        </el-date-picker>


                      </div>


                    </div> -->

                </div>


                <el-row type="flex" justify="space-between">

                    <el-col :span="22">

                        <el-button type="primary" icon="el-icon-search" @click="getOrderStatistics"
                                   style="padding: 6px 12px;">搜索
                        </el-button>

                    </el-col>


                </el-row>

            </div>

        </div>

        <div class="charts-box">
            <!-- 今日各模式订单 -->
            <div style="width: 50%;">
                <div id="modelCharts" style="height: 400px;"></div>
            </div>

            <!-- 今日各模式订单金额 -->
            <div style="width: 50%;">
                <div id="modelMoneyCharts" style="height: 400px;"></div>
            </div>

            <!-- 今日各端口订单 -->
            <div style="width: 50%;">
                <div id="orderFromCharts" style="height: 400px;"></div>
            </div>

            <!-- 今日各端口订单金额 -->
            <div style="width: 50%;">
                <div id="orderFromMoneyCharts" style="height: 400px;"></div>
            </div>


            <!-- 一个月内单量及金额 -->

            <div style="width: 100%; text-align: right;">
                <span class="title" style="margin-right: 5px;">年月:</span>
                <el-date-picker v-model="month_time" type="month" placeholder="选择月份" format="yyyy-MM"
                                value-format="yyyy-MM"
                                @change="monthEchartsInit">
                </el-date-picker>
            </div>

            <div class="monthCharts-box" style="width:100%">
                <div  id="monthCharts"  style="height: 400px"></div>
                <div class="monthCharts-bg" style="height:400px; text-align: center" v-show="!echars_loading">
                    <span class="el-icon-loading"></span>
                    <p>正在请求中...</p>
                </div>
            </div>

        </div>

    </div>

</template>

<script>
    var _this;
    import echarts from 'echarts';

    export default {
        data() {
            return {


                company_name: '',
                search_time: '',
                month_time: '',


                echars_loading: false,


                //模式订单
                modelCharts: '',
                modelOption: {
                    color:['#36a1d9','#3cc2e3','#66dfe2','#9ee7b7','#fdda5a','#ff9e7e','#fa7292',
                        '#df60ad','#e590d1','#e7bbf3','#a08be4','#7e89cd','#4970df'],
                    title: {
                        text: '模式订单量',
                        subtext: '',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },
                    series: [{
                        name: '模式订单量',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                },

                //模式金额
                modelMoneyCharts: '',
                modelMoneyOption: {
                    color:['#36a1d9','#3cc2e3','#66dfe2','#9ee7b7','#fdda5a','#ff9e7e','#fa7292',
                        '#df60ad','#e590d1','#e7bbf3','#a08be4','#7e89cd','#4970df'],
                    title: {
                        text: '模式金额',
                        subtext: '',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },
                    series: [{
                        name: '模式金额',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                },


                //端口订单
                orderFromCharts: '',
                orderFromOption: {
                    color:['#36a1d9','#3cc2e3','#66dfe2','#9ee7b7','#fdda5a','#ff9e7e','#fa7292',
                        '#df60ad','#e590d1','#e7bbf3','#a08be4','#7e89cd','#4970df'],
                    title: {
                        text: '端口订单量',
                        subtext: '',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },
                    series: [{
                        name: '端口订单量',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                },

                //端口订单金额
                orderFromMoneyCharts: '',
                orderFromMoneyOption: {
                    color:['#36a1d9','#3cc2e3','#66dfe2','#9ee7b7','#fdda5a','#ff9e7e','#fa7292',
                        '#df60ad','#e590d1','#e7bbf3','#a08be4','#7e89cd','#4970df'],
                    title: {
                        text: '端口订单金额',
                        subtext: '',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left',
                        data: []
                    },
                    series: [{
                        name: '端口订单金额',
                        type: 'pie',
                        radius: '55%',
                        center: ['50%', '60%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                },


                // 一个月内单量及金额
                monthCharts: '',
                monthOption: {
                    title: {
                        text: '一个月内单量及金额'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: ['单量', '金额']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {},
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [{
                        name: '单量',
                        type: 'line',
                        data: [],
                        smooth: true,
                        color:'#409eff',
                    },
                    {
                        name: '金额',
                        type: 'line',
                        data: [],
                        smooth: true,
                        color: "#f67745"
                    }
                    ]
                },
                search_month: {
                    page: 1,
                    limit: 10
                },

                search_data: {
                    fixed_array: ''
                },
                search_rules: {
                    fixed_array: {
                        placeholder: '起止时间',
                        rules: {
                            required: true,
                            message: '起止时间不能为空',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    }


                }


            };
        },
        created() {
            _this = this;


            // 获取当前年月
            var date = new Date;
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = (month < 10 ? '0' + month : month);
            _this.month_time = (year.toString() + '-' + month.toString());


            // _this.getOrderStatistics();
        },
        mounted() {


            _this.monthEchartsInit();

            _this.echartsInit();

        },
        methods: {

            monthEchartsInit() {

                console.log(_this.month_time);


                _this.monthOption.xAxis.data = [];

                _this.monthOption.series[0].data = [];

                _this.monthOption.series[1].data = [];

                _this.echars_loading = false;

                _this.getData();

            },


            getData() {

                _this.$post(
                    '/statistics/getOrderMonthCount', {
                        month_time: _this.month_time,
                        page: _this.search_month.page
                    }
                ).then(res => {


                    // 日期
                    _this.monthOption.xAxis.data.push(res.data.list.key);

                    // 单量
                    _this.monthOption.series[0].data.push(res.data.list.count);

                    // 金额
                    _this.monthOption.series[1].data.push(res.data.list.finish_amount);


                    if (_this.search_month.page < Number(res.data.count)) {
                        _this.search_month.page += 1;
                        _this.getData();
                    } else {
                        _this.search_month.page = 1;
                        _this.echars_loading = true;
                        this.monthCharts = echarts.init(document.getElementById('monthCharts'));
                        this.monthCharts.setOption(_this.monthOption);
                    }


                }).catch((err) => {

                });

            },

            echartsInit() {

                this.modelCharts = echarts.init(document.getElementById('modelCharts'));
                this.modelCharts.setOption(_this.modelOption);

                this.modelMoneyCharts = echarts.init(document.getElementById('modelMoneyCharts'));
                this.modelMoneyCharts.setOption(_this.modelMoneyOption);

                this.orderFromCharts = echarts.init(document.getElementById('orderFromCharts'));
                this.orderFromCharts.setOption(_this.orderFromOption);

                this.orderFromMoneyCharts = echarts.init(document.getElementById('orderFromMoneyCharts'));
                this.orderFromMoneyCharts.setOption(_this.orderFromMoneyOption);


            },


            getOrderStatistics() {

                _this.$post(
                    '/statistics/getOrderModelCount',
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {

                        _this.orderFromOption.legend.data = [];

                        _this.orderFromOption.series[0].data = [];

                        _this.orderFromMoneyOption.legend.data = [];

                        _this.orderFromMoneyOption.series[0].data = [];

                        _this.modelOption.legend.data = [];

                        _this.modelOption.series[0].data = [];

                        _this.modelMoneyOption.legend.data = [];

                        _this.modelMoneyOption.series[0].data = [];


                        // 端口订单echarts插入数据
                        for (let i = 0; i < res.data.platform_count.length; i++) {

                            _this.orderFromOption.legend.data.push(res.data.platform_count[i].name);

                            _this.orderFromOption.series[0].data.push({
                                'value': res.data.platform_count[i].count,
                                'name': res.data.platform_count[i].name
                            });


                        }

                        if (_this.orderFromOption.legend.data.length == 0) {

                            _this.orderFromOption.title.text = '端口订单量暂无数据';

                        } else {

                            _this.orderFromOption.title.text = '端口订单量';

                        }


                        // 端口订单金额echarts插入数据
                        for (let i = 0; i < res.data.platform_money.length; i++) {

                            _this.orderFromMoneyOption.legend.data.push(res.data.platform_money[i].name);

                            _this.orderFromMoneyOption.series[0].data.push({
                                'value': res.data.platform_money[i].finish_amount,
                                'name': res.data.platform_money[i].name
                            });


                        }

                        if (_this.orderFromMoneyOption.legend.data.length == 0) {

                            _this.orderFromMoneyOption.title.text = '端口订单金额暂无数据';

                        } else {

                            _this.orderFromMoneyOption.title.text = '端口订单金额';

                        }


                        //模式订单echarts插入数据
                        for (let i = 0; i < res.data.order_mode_count.length; i++) {

                            _this.modelOption.legend.data.push(res.data.order_mode_count[i].name);

                            _this.modelOption.series[0].data.push({
                                'value': res.data.order_mode_count[i].count,
                                'name': res.data.order_mode_count[i].name
                            });

                        }

                        if (_this.modelOption.legend.data.length == 0) {

                            _this.modelOption.title.text = '模式订单量暂无数据';

                        } else {

                            _this.modelOption.title.text = '模式订单量';

                        }


                        //模式金额echarts插入数据
                        for (let i = 0; i < res.data.order_mode_money.length; i++) {

                            _this.modelMoneyOption.legend.data.push(res.data.order_mode_money[i].name);

                            _this.modelMoneyOption.series[0].data.push({
                                'value': res.data.order_mode_money[i].finish_amount,
                                'name': res.data.order_mode_money[i].name
                            });

                        }


                        if (_this.modelMoneyOption.legend.data.length == 0) {

                            _this.modelMoneyOption.title.text = '模式金额暂无数据';

                        } else {

                            _this.modelMoneyOption.title.text = '模式金额';

                        }

                        _this.echartsInit();


                    }).catch((err) => {

                });


                _this.monthEchartsInit();


            },


            // 搜索时间选择触发
            timeChange(val) {

                if (val !== null) {
                    _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));

                } else {
                    _this.search_data.fixed_array = '';
                }

                console.log(_this.search_data);

            }


        }
    };
</script>

<style scoped>
    .monthCharts-box{
        position: relative;
    }

    .monthCharts-bg{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        position:absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.2);
        color: #fff;
    }

    .handle-select{
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }

    .table-head {
        margin-bottom: 20px;
    }


    .table-head > div .title {
        display: block;
        width: 100px;
        padding-right: 16px;
        text-align: right;
        box-sizing: border-box;
        color: #606266;
        height: 28px;
        line-height: 28px;
        float: left;
    }

    .table-head-search {
        display: flex;

    }

    .table-head .search-radio {
        width: 100%;
    }

    .container-tabs .el-tabs__item.is-top.is-active {
        border: 1px solid #dcdfe6;
    }

    .charts-box {
        display: flex;
        flex-wrap: wrap;

    }
</style>
<style>
    .table-head-search .el-select.el-select--small,
    .table-head .el-radio-group {
        width: calc(100% - 100px);
    }

    .table-head-search .el-select.el-select--small .el-input.el-input--small.el-input--suffix {
        width: 100% !important;
    }

    .table-head > div .el-input--small {
        width: calc(100% - 100px);

        float: left;
    }


    .table-head > div .el-input--small .el-input__inner {
        height: 28px;
        line-height: 28px;

    }

    .container .el-tabs__header {
        margin-bottom: 0 !important;
    }

    .table-head .el-checkbox__inner {
        display: none;
    }

    .table-head .el-radio__inner {
        display: none;
    }

    .table-head .el-checkbox-group {
        display: inline-block;
    }

    .table-head .el-checkbox,
    .table-head .el-radio {
        border: 0px solid transparent;
        background-color: transparent;
        border-radius: 5px !important;
    }

    .table-head .el-checkbox.is-checked,
    .table-head .el-radio.is-checked {
        border: 0px solid #409EFF;
        /* background-color: #ecf5ff;  */
    }

    .table-head .el-checkbox__label,
    .table-head .el-radio__label {
        padding: 0;
    }


    .container-tabs .el-tabs__nav.is-top {
        border: 0;
    }

    .container-tabs .el-tabs__item.is-top {
        border: 1px solid transparent;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }

    .container-tabs .el-tabs__header.is-top {
        border-bottom: 0;
    }

    .el-col.el-col-6 > span {
        display: inline-block;
        width: 100px;
        text-align: left;
    }

    .sub #tab-new .table-title {
        color: #65c138;
    }

    .sub #tab-proceed .table-title {
        color: #b6ae3a;
    }

    .sub #tab-serving .table-title {
        color: #409eff;
    }

    .sub #tab-unpaid .table-title {
        color: #f67745;
    }

    .sub #tab-paid .table-title {
        color: #606266;
    }

    .sub #tab-order_cancel .table-title {
        color: #606266;
    }

    .order-table-lists .el-table__body .cell {
        color: #000;
        font-weight: 500;
        font-size: 18px;
    }

    .el-date-range-picker__time-header {
        display: block;
    }
</style>